require('jquery')
require('packery/dist/packery.pkgd')

jQuery(function () {
  $('.packery').packery({
    itemSelector: '.grid-item',
    gutter: 10
  })
})
